export function getHoursAndMinutesForDuration(maxValue = 0) {
  const completeHours = Math.trunc(maxValue / 60);
  const remainderMinutes = (maxValue % 60);
  return [completeHours, remainderMinutes];
}
